import { render, staticRenderFns } from "./Pressure.vue?vue&type=template&id=a68c010a&scoped=true&"
import script from "./Pressure.vue?vue&type=script&lang=js&"
export * from "./Pressure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68c010a",
  null
  
)

export default component.exports